import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytes',
})
export class BytesPipe implements PipeTransform {
  public transform(value: string) {
    if (!value) return null;

    const trimmedValue: string = value.trim();

    const unitPart: string = trimmedValue.slice(-2);
    const valuePart: number = parseInt(trimmedValue.slice(0, -2), 10);

    switch (unitPart) {
    case 'KB':
      return valuePart * 1024;
    case 'MB':
      return valuePart * 1024 * 1024;
    case 'GB':
      return valuePart * 1024 * 1024 * 1024;
    default:
      return valuePart;
    }
  }
}
